.logo { object-fit: contain; border-radius: var(--radius-logo); flex: none; }
.placeholder {
  flex: none; display: inline-flex; align-items: center; justify-content: center;
  border-radius: var(--radius-logo); background: var(--content-border); color: var(--content-secondary);
  font-weight: 600; overflow: hidden;
}
